import PayPeriodCard from './cards/PayPeriodCard';
import MappingCard from './cards/MappingCard';
import PreviewCard from './cards/PreviewCard';
import ResultCard from './cards/ResultCard';
import type { DirectAllocationChat } from './useDirectAllocationChat';
import type { DirectAllocationStepKind } from './types';

/** Picks the one interactive card for the chat's current Direct Allocation step. */
export default function DirectAllocationCard({
	step,
	chat,
}: {
	step: DirectAllocationStepKind;
	chat: DirectAllocationChat;
}) {
	switch (step) {
		case 'pay_period':
			return <PayPeriodCard chat={chat} />;
		case 'mapping':
			return <MappingCard chat={chat} />;
		case 'preview':
			return <PreviewCard chat={chat} />;
		case 'result':
			return <ResultCard chat={chat} />;
		default:
			return null;
	}
}
